export default __webpack_public_path__ + "static/media/conley.8d5a82cd.jpg";